<template>
   <vs-table :data="data" maxHeight="60vh">
    <template slot="thead">
      <vs-th>{{ $t('folio') | capitalize }}</vs-th>
      <vs-th>{{ $t('bulk')|capitalize}}({{$t('bundle')|capitalize}})</vs-th>
      <vs-th>{{ $t('requirement_key') | capitalize }}</vs-th>
      <vs-th>{{ $t('no_part') | capitalize }}</vs-th>
      <vs-th>{{ $t('description') | capitalize }}</vs-th>
      <vs-th>{{ $t('english_description') | capitalize }}</vs-th>
      <vs-th>{{ $t('quantity') | capitalize }}</vs-th>
      <vs-th>{{ $t('Unidad medida comercial') | capitalize }}</vs-th>
      <vs-th>{{ $t('Unidad medida tarifa') | capitalize }}</vs-th>
      <vs-th>{{ $t('Factor de conversion') | capitalize }}</vs-th>
      <vs-th>{{ $t('warehouse') | capitalize }}</vs-th>
      <vs-th>{{ $t('Pais de origen') | capitalize }}</vs-th>
      <vs-th>{{ $t('weight') | capitalize }} KG</vs-th>
      <vs-th>{{ $t('weight') | capitalize }} LB</vs-th>
      <vs-th>{{ $t('V. Unit. Compra') | capitalize }}</vs-th>
      <vs-th>{{ $t('V. Unit. Comercial') | capitalize }}</vs-th>
      <vs-th>{{ $t('Valor Total USD') | capitalize }}</vs-th>
      <vs-th>{{ $t('Marca') | capitalize }}</vs-th>
      <vs-th>{{ $t('model') | capitalize }}</vs-th>
      <vs-th>{{ $t('serie') | capitalize }}</vs-th>
    </template>
    <template slot-scope="{ data }">
      <vs-tr :key="i" v-for="(tr, i) in data">
        <vs-td>{{ data[i].fields['Folio Factura'] }}</vs-td>
        <vs-td>{{ data[i].fields['Bultos (Bundles)'] }}</vs-td>
        <vs-td>{{ data[i].fields['Clave de pedimento'] }}</vs-td>
        <vs-td>{{ data[i].fields['No. parte'] }}</vs-td>
        <vs-td>{{ data[i].fields['Descripcion'] }}</vs-td>
        <vs-td>{{ data[i].fields['Descripcion en ingles'] }}</vs-td>
        <vs-td>{{ data[i].fields['Cantidad'] }}</vs-td>
        <vs-td>{{ data[i].fields['Unidad medida comercial'] }}</vs-td>
        <vs-td>{{ data[i].fields['Unidad medida tarifa'] }}</vs-td>
        <vs-td>{{ data[i].fields['Factor de conversion'] }}</vs-td>
        <vs-td>{{ data[i].fields['WareHouse'] }}</vs-td>
        <vs-td>{{ data[i].fields['Pais de origen'] }}</vs-td>
        <vs-td>{{ data[i].fields['Peso KG'] }}</vs-td>
        <vs-td>{{ data[i].fields['Peso LB'] }}</vs-td>
        <vs-td>{{ data[i].fields['V. Unit. Compra'] }}</vs-td>
        <vs-td>{{ data[i].fields['V. Unit. Comercial'] }}</vs-td>
        <vs-td>{{ data[i].fields['Valor Total USD'] }}</vs-td>
        <vs-td>{{ data[i].fields['Marca'] }}</vs-td>
        <vs-td>{{ data[i].fields['Modelo'] }}</vs-td>
        <vs-td>{{ data[i].fields['Serie'] }}</vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
  },
}
</script>

<style>
</style>


}
